module.exports = __webpack_public_path__ + "static/media/related-cases6.73cdbd61.jpg";